import axios from "axios";

export async function callApiWithRetry({ url, maxRetries = 5, ms = 3000, retryOnSuccess = () => false, retryOnFailure = () => false, options = {}, attempts = 0 }) {
    if (attempts >= maxRetries) return null;
    try {
        const response = await axios(url, options);
        const data = await response?.data;
        // success
        if (data && retryOnSuccess(data)) return response;
        // wait before next call
        await wait(ms);
        attempts += 1;
        return callApiWithRetry({
            url,
            maxRetries,
            ms,
            retryOnSuccess,
            retryOnFailure,
            options,
            attempts
        });
    } catch (error) {
        if (retryOnFailure(error?.response?.data)) {
            await wait(ms);
            attempts += 1;
            return callApiWithRetry({
                url,
                maxRetries,
                ms,
                retryOnSuccess,
                retryOnFailure,
                options,
                attempts
            });
        }
        return null;
    }
}

async function wait(ms) {
    await new Promise(res => {
        setTimeout(() => res({}), ms);
    });
}
